export const formatIban = (iban: string, obfuscate = true) => {
  const parts = iban.match(/[\s\S]{1,4}/g);
  if (obfuscate && parts.length > 6) {
    parts[2] = '****';
    parts[3] = '****';
    parts[4] = '****';
  }
  return parts.join(' ');
};
